<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<app-dialog-banner [text]="data.title || 'Select Attachment'" [dialogRef]="dialogRef"></app-dialog-banner>
<mat-dialog-content style="padding: 0">
    @if (data.attachments.length === 0) {
        <p class="no-attachments">No attachments available.</p>
    } @else {
        <div class="attachment-list">
            <div class="list-header">
                <div class="col-icon"></div>
                <div class="col-name">Name</div>
                <div class="col-size">Size</div>
                <div class="col-warn"></div>
            </div>
            @for (attach of data.attachments; track attach.id) {
                <div class="attachment-row" (click)="pickAttachment(attach)">
                    <div class="col-icon">
                        <app-file-type-icon [ext]="attach.ext"></app-file-type-icon>
                    </div>
                    <div class="col-name" [matTooltip]="attach.notes">{{ attach.name }}</div>
                    <div class="col-size">{{ attach.size | byteCount }}</div>
                    <div class="col-warn">
                        @if (warnLevel(attach) === 2) {
                            <mat-icon color="warn" [matTooltip]="limitText">error</mat-icon>
                        } @else if (warnLevel(attach) === 1) {
                            <mat-icon class="warn-yellow" [matTooltip]="warnText">warning</mat-icon>
                        }
                    </div>
                </div>
            }
        </div>
    }
</mat-dialog-content>
